// Generated by ReScript, PLEASE EDIT WITH CARE

import * as IndexJs from "./index.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as AuctionTypes$LiveRoom from "../../AuctionTypes.bs.js";

var _map = {"RegistrationPending":"registration pending","ActionNeededToBid":"action needed to bid","PendingBiddingAgent":"registration pending:bidding agent","ClientNoId":"no id"};

var _revMap = {"registration pending":"RegistrationPending","action needed to bid":"ActionNeededToBid","registration pending:bidding agent":"PendingBiddingAgent","no id":"ClientNoId"};

function messageTypeToJs(param) {
  return _map[param];
}

function messageTypeFromJs(param) {
  return _revMap[param];
}

var _map$1 = {"ConnectionError":"connection error","BidTooLow":"bid too low","BidIsWithYou":"bid is with you","AbsenteeBid":"absentee bid","BidRequest":"bid request"};

var _revMap$1 = {"connection error":"ConnectionError","bid too low":"BidTooLow","bid is with you":"BidIsWithYou","absentee bid":"AbsenteeBid","bid request":"BidRequest"};

function bidResultToJs(param) {
  return _map$1[param];
}

function bidResultFromJs(param) {
  return _revMap$1[param];
}

var _map$2 = {"English":"English","French":"French","German":"German","Russian":"Russian","Italian":"Italian","Spanish":"Spanish","Japanese":"Japanese","TraditionalChinese":"Traditional Chinese","SimplifiedChinese":"Simplified Chinese","Icelandic":"Icelandic"};

var _revMap$2 = {"English":"English","French":"French","German":"German","Russian":"Russian","Italian":"Italian","Spanish":"Spanish","Japanese":"Japanese","Traditional Chinese":"TraditionalChinese","Simplified Chinese":"SimplifiedChinese","Icelandic":"Icelandic"};

function languageNewToJs(param) {
  return _map$2[param];
}

function languageNewFromJs(param) {
  return _revMap$2[param];
}

var _map$3 = {"AuctionRoom":"auction room","AuctionLotList":"auction lot list","LotPage":"lot page","Account":"account","PlaceBidPage":"place bid page"};

var _revMap$3 = {"auction room":"AuctionRoom","auction lot list":"AuctionLotList","lot page":"LotPage","account":"Account","place bid page":"PlaceBidPage"};

function currencySelectionOriginToJs(param) {
  return _map$3[param];
}

function currencySelectionOriginFromJs(param) {
  return _revMap$3[param];
}

var _map$4 = {"Pending":"pending","Approved":"approved","Declined":"declined"};

var _revMap$4 = {"pending":"Pending","approved":"Approved","declined":"Declined"};

function enrollmentStatusToJs(param) {
  return _map$4[param];
}

function enrollmentStatusFromJs(param) {
  return _revMap$4[param];
}

var _map$5 = {"English":"English","French":"French","German":"German","Russian":"Russian","Italian":"Italian","Spanish":"Spanish","Japanese":"Japanese","TraditionalChinese":"Traditional Chinese","SimplifiedChinese":"Simplified Chinese","Icelandic":"Icelandic"};

var _revMap$5 = {"English":"English","French":"French","German":"German","Russian":"Russian","Italian":"Italian","Spanish":"Spanish","Japanese":"Japanese","Traditional Chinese":"TraditionalChinese","Simplified Chinese":"SimplifiedChinese","Icelandic":"Icelandic"};

function languageToJs(param) {
  return _map$5[param];
}

function languageFromJs(param) {
  return _revMap$5[param];
}

var _map$6 = {"On":"on","Off":"off"};

var _revMap$6 = {"on":"On","off":"Off"};

function audioStreamToggleToJs(param) {
  return _map$6[param];
}

function audioStreamToggleFromJs(param) {
  return _revMap$6[param];
}

var _map$7 = {"Bidder":"bidder","Watcher":"watcher"};

var _revMap$7 = {"bidder":"Bidder","watcher":"Watcher"};

function participantTypeToJs(param) {
  return _map$7[param];
}

function participantTypeFromJs(param) {
  return _revMap$7[param];
}

var _map$8 = {"Live":"live","Timed":"timed","Open":"open","Floor":"floor","Phone":"phone","Absentee":"absentee"};

var _revMap$8 = {"live":"Live","timed":"Timed","open":"Open","floor":"Floor","phone":"Phone","absentee":"Absentee"};

function bidTypeToJs(param) {
  return _map$8[param];
}

function bidTypeFromJs(param) {
  return _revMap$8[param];
}

var _map$9 = {"Registration":"Registration","Ecommerce":"Ecommerce","Search":"Search","Page":"Page","TeamMember":"Team Member","Editorial":"Editorial","ContactUs":"Contact Us","About":"About","Faq":"FAQ","Departments":"Departments","Locations":"Locations","EventSeries":"Event Series","StoriesVideos":"Stories & Videos","Video":"Video","Slideshow":"Slideshow","Section":"Section","Article":"Article","Brands":"Brands","Artists":"Artists","Homepage":"Homepage","MyAccount":"My Account"};

var _revMap$9 = {"Registration":"Registration","Ecommerce":"Ecommerce","Search":"Search","Page":"Page","Team Member":"TeamMember","Editorial":"Editorial","Contact Us":"ContactUs","About":"About","FAQ":"Faq","Departments":"Departments","Locations":"Locations","Event Series":"EventSeries","Stories & Videos":"StoriesVideos","Video":"Video","Slideshow":"Slideshow","Section":"Section","Article":"Article","Brands":"Brands","Artists":"Artists","Homepage":"Homepage","My Account":"MyAccount"};

function contentTypeToJs(param) {
  return _map$9[param];
}

function contentTypeFromJs(param) {
  return _revMap$9[param];
}

var _map$10 = {"LiveRoom":"live_room","TelephoneBid":"telephone_bid","LiveAdvance":"live_advance","LiveAbsentee":"live_absentee","OnlineOnly":"online_only"};

var _revMap$10 = {"live_room":"LiveRoom","telephone_bid":"TelephoneBid","live_advance":"LiveAdvance","live_absentee":"LiveAbsentee","online_only":"OnlineOnly"};

function bidMethodToJs(param) {
  return _map$10[param];
}

function bidMethodFromJs(param) {
  return _revMap$10[param];
}

var _map$11 = {"On":"on","Off":"off"};

var _revMap$11 = {"on":"On","off":"Off"};

function audioStreamingToggleToToJs(param) {
  return _map$11[param];
}

function audioStreamingToggleToFromJs(param) {
  return _revMap$11[param];
}

var _map$12 = {"ExpandLotList":"expand lot list","ClickCurrentLot":"click current lot","ClickUpcomingLot":"click upcoming lot","ClickClosedLot":"click closed lot","ClickCataloguing":"click cataloguing","ClickAlternativeImage":"click alternative image","InitialSwipeLotGallery":"initial swipe lot gallery","InitialSwipeBetweenLots":"initial swipe between lots","ClickCurrentLotCard":"click current lot card","ClickSaleroomNotice":"click saleroom notice","ClickLiterature":"click literature","ClickExhibited":"click exhibited","ClickProvenance":"click provenance","ClickCatalogueNote":"click catalogue note","ClickDisclaimers":"click disclaimers","ClickConditionReport":"click condition report"};

var _revMap$12 = {"expand lot list":"ExpandLotList","click current lot":"ClickCurrentLot","click upcoming lot":"ClickUpcomingLot","click closed lot":"ClickClosedLot","click cataloguing":"ClickCataloguing","click alternative image":"ClickAlternativeImage","initial swipe lot gallery":"InitialSwipeLotGallery","initial swipe between lots":"InitialSwipeBetweenLots","click current lot card":"ClickCurrentLotCard","click saleroom notice":"ClickSaleroomNotice","click literature":"ClickLiterature","click exhibited":"ClickExhibited","click provenance":"ClickProvenance","click catalogue note":"ClickCatalogueNote","click disclaimers":"ClickDisclaimers","click condition report":"ClickConditionReport"};

function biddingInteractionTypeToJs(param) {
  return _map$12[param];
}

function biddingInteractionTypeFromJs(param) {
  return _revMap$12[param];
}

var sysInApp = {
  contents: false
};

var sysLanguage = {
  contents: undefined
};

function init(inApp, language, param) {
  if (inApp !== undefined) {
    sysInApp.contents = Belt_Option.getWithDefault(inApp, false);
  }
  if (language !== undefined) {
    sysLanguage.contents = language;
    return ;
  }
  
}

function logSegmentEvent(eventName, eventProperties) {
  var apply = (function (eventName, eventProperties) {
        if (typeof window === 'undefined') { return; }
        window.analytics.track(eventName, eventProperties);
      });
  apply(eventName, eventProperties);
}

function bidPlaced(bidAmount, bidCurrency, bidResult, customerId, auth0Id, preferredMemberFlag, clientLevel, saleId, productId, lotVikingId, lotName, auctionId, auctionName, departmentCategory, bidType) {
  var segment = window.analytics;
  if (segment !== undefined) {
    Caml_option.valFromOption(segment).identify(undefined, {
          customer_id: customerId,
          auth0_id: auth0Id,
          preferred_member_flag: preferredMemberFlag,
          client_level: clientLevel
        }, undefined);
  }
  var prim_bid_result = bidResultToJs(bidResult);
  var prim_bid_type = Belt_Option.map(bidType, bidTypeToJs);
  var prim_in_app = sysInApp.contents;
  var prim_language = Belt_Option.map(sysLanguage.contents, languageToJs);
  var prim = {
    bid_amount: bidAmount,
    bid_currency: bidCurrency,
    bid_result: prim_bid_result,
    sale_id: saleId,
    product_id: productId,
    lot_viking_id: lotVikingId,
    lot_name: lotName,
    auction_id: auctionId,
    auction_name: auctionName,
    department_category: departmentCategory,
    bid_type: prim_bid_type,
    in_app: prim_in_app,
    language: prim_language,
    customer_id: customerId,
    auth0_id: auth0Id,
    preferred_member_flag: preferredMemberFlag,
    client_level: clientLevel
  };
  IndexJs.bidPlaced(prim);
}

function authenticated(userId_, customerId, auth0Id, preferredMemberFlag, clientLevel, ssoLogin) {
  var segment = window.analytics;
  if (segment !== undefined) {
    Caml_option.valFromOption(segment).identify(userId_, {
          customer_id: customerId,
          auth0_id: auth0Id,
          preferred_member_flag: preferredMemberFlag,
          client_level: clientLevel
        }, undefined);
  }
  var prim_in_app = sysInApp.contents;
  var prim_language = Belt_Option.map(sysLanguage.contents, languageToJs);
  var prim = {
    sso_login: ssoLogin,
    in_app: prim_in_app,
    language: prim_language,
    customer_id: customerId,
    auth0_id: auth0Id,
    preferred_member_flag: preferredMemberFlag,
    client_level: clientLevel
  };
  IndexJs.authenticated(prim);
}

function navigated(segmentPageName_, saleId, saleType, productId, departmentCategory, contentType, previousCta, previousPagename, cmpTrackingcode, auctionId, customerId, auth0Id, preferredMemberFlag) {
  var segment = window.analytics;
  if (segment !== undefined) {
    var segment$1 = Caml_option.valFromOption(segment);
    segment$1.identify(undefined, {
          customer_id: customerId,
          auth0_id: auth0Id,
          preferred_member_flag: preferredMemberFlag
        }, undefined);
    segment$1.page(segmentPageName_, {
          sale_id: saleId,
          sale_type: saleType,
          product_id: productId,
          department_category: departmentCategory,
          content_type: contentTypeToJs(contentType),
          previous_cta: previousCta,
          previous_pagename: previousPagename,
          cmp_trackingcode: cmpTrackingcode,
          auctionId: auctionId,
          language: Belt_Option.map(sysLanguage.contents, languageToJs),
          auth0_id: auth0Id,
          customer_id: customerId,
          preferred_member_flag: preferredMemberFlag,
          in_app: sysInApp.contents
        }, undefined, undefined, (function (param) {
            
          }));
  }
  var prim_content_type = contentTypeToJs(contentType);
  var prim_in_app = sysInApp.contents;
  var prim_language = Belt_Option.map(sysLanguage.contents, languageToJs);
  var prim = {
    sale_id: saleId,
    sale_type: saleType,
    product_id: productId,
    department_category: departmentCategory,
    content_type: prim_content_type,
    previous_cta: previousCta,
    previous_pagename: previousPagename,
    cmp_trackingcode: cmpTrackingcode,
    auctionId: auctionId,
    in_app: prim_in_app,
    language: prim_language,
    customer_id: customerId,
    auth0_id: auth0Id,
    preferred_member_flag: preferredMemberFlag
  };
  IndexJs.navigated(prim);
}

function loginAttemptError(param) {
  var prim_in_app = sysInApp.contents;
  var prim_language = Belt_Option.map(sysLanguage.contents, languageToJs);
  var prim = {
    in_app: prim_in_app,
    language: prim_language
  };
  IndexJs.loginAttemptError(prim);
}

function auctionRoomEntered(saleId, auctionName, auctionId, participantType, customerId, auth0Id, preferredMemberFlag) {
  var segment = window.analytics;
  if (segment !== undefined) {
    Caml_option.valFromOption(segment).identify(undefined, {
          customer_id: customerId,
          auth0_id: auth0Id,
          preferred_member_flag: preferredMemberFlag
        }, undefined);
  }
  var prim_in_app = sysInApp.contents;
  var prim_language = Belt_Option.map(sysLanguage.contents, languageToJs);
  var prim_participant_type = participantTypeToJs(participantType);
  var prim = {
    auction_id: auctionId,
    auction_name: auctionName,
    auth0_id: auth0Id,
    customer_id: customerId,
    in_app: prim_in_app,
    language: prim_language,
    participant_type: prim_participant_type,
    preferred_member_flag: preferredMemberFlag,
    sale_id: saleId
  };
  IndexJs.auctionRoomEntered(prim);
}

function auctionRoomInteraction(participantType, biddingInteractionType, customerId, auth0Id, preferredMemberFlag) {
  var segment = window.analytics;
  if (segment !== undefined) {
    Caml_option.valFromOption(segment).identify(undefined, {
          customer_id: customerId,
          auth0_id: auth0Id,
          preferred_member_flag: preferredMemberFlag
        }, undefined);
  }
  var prim_participant_type = participantTypeToJs(participantType);
  var prim_bidding_interaction_type = biddingInteractionTypeToJs(biddingInteractionType);
  var prim_in_app = sysInApp.contents;
  var prim_language = Belt_Option.map(sysLanguage.contents, languageToJs);
  var prim = {
    participant_type: prim_participant_type,
    bidding_interaction_type: prim_bidding_interaction_type,
    in_app: prim_in_app,
    language: prim_language,
    customer_id: customerId,
    auth0_id: auth0Id,
    preferred_member_flag: preferredMemberFlag
  };
  IndexJs.auctionRoomInteraction(prim);
}

function loginToBid(saleId, productId, lotVikingId, lotName, auctionId, auctionName, departmentCategory) {
  var prim_in_app = sysInApp.contents;
  var prim_language = Belt_Option.map(sysLanguage.contents, languageToJs);
  var prim = {
    sale_id: saleId,
    product_id: productId,
    lot_viking_id: lotVikingId,
    lot_name: lotName,
    auction_id: auctionId,
    auction_name: auctionName,
    department_category: departmentCategory,
    in_app: prim_in_app,
    language: prim_language
  };
  IndexJs.loginToBid(prim);
}

function audioStreamingToggle(audioStreamingToggleTo, auctionId, auctionName, saleId, audioStreamToggle) {
  var segment = window.analytics;
  if (segment !== undefined) {
    Caml_option.valFromOption(segment).identify(undefined, {
          audio_stream_toggle: audioStreamToggleToJs(audioStreamToggle)
        }, undefined);
  }
  var prim_audio_streaming_toggle_to = audioStreamingToggleToToJs(audioStreamingToggleTo);
  var prim_in_app = sysInApp.contents;
  var prim_language = Belt_Option.map(sysLanguage.contents, languageToJs);
  var prim_audio_stream_toggle = audioStreamToggleToJs(audioStreamToggle);
  var prim = {
    audio_streaming_toggle_to: prim_audio_streaming_toggle_to,
    auction_id: auctionId,
    auction_name: auctionName,
    sale_id: saleId,
    in_app: prim_in_app,
    language: prim_language,
    audio_stream_toggle: prim_audio_stream_toggle
  };
  IndexJs.audioStreamingToggle(prim);
}

function registrationPendingMessageViewed(saleId, productId, messageType, bidMethod, customerId, auth0Id, preferredMemberFlag, intendedBidAmount, intendedBidCurrency) {
  var segment = window.analytics;
  if (segment !== undefined) {
    Caml_option.valFromOption(segment).identify(undefined, {
          customer_id: customerId,
          auth0_id: auth0Id,
          preferred_member_flag: preferredMemberFlag
        }, undefined);
  }
  var prim_message_type = messageTypeToJs(messageType);
  var prim_bid_method = bidMethodToJs(bidMethod);
  var prim_in_app = sysInApp.contents;
  var prim_language = Belt_Option.map(sysLanguage.contents, languageToJs);
  var prim = {
    sale_id: saleId,
    product_id: productId,
    message_type: prim_message_type,
    bid_method: prim_bid_method,
    intended_bid_amount: intendedBidAmount,
    intended_bid_currency: intendedBidCurrency,
    in_app: prim_in_app,
    language: prim_language,
    customer_id: customerId,
    auth0_id: auth0Id,
    preferred_member_flag: preferredMemberFlag
  };
  IndexJs.registrationPendingMessageViewed(prim);
}

function currencySelected(currencyNew, saleId, currencySelectionOrigin, currencyAuction) {
  var prim_currency_selection_origin = currencySelectionOriginToJs(currencySelectionOrigin);
  var prim_in_app = sysInApp.contents;
  var prim_language = Belt_Option.map(sysLanguage.contents, languageToJs);
  var prim = {
    currency_new: currencyNew,
    sale_id: saleId,
    currency_selection_origin: prim_currency_selection_origin,
    currency_auction: currencyAuction,
    in_app: prim_in_app,
    language: prim_language
  };
  IndexJs.currencySelected(prim);
}

function notAllowedToBid(customerId, preferredMemberFlag, messageType, saleId) {
  var prim_preferred_member_flag = Belt_Option.getWithDefault(preferredMemberFlag, false);
  var prim_in_app = sysInApp.contents;
  var prim_message_type = messageTypeToJs(messageType);
  var prim = {
    preferred_member_flag: prim_preferred_member_flag,
    in_app: prim_in_app,
    customer_id: customerId,
    message_type: prim_message_type,
    sale_id: saleId
  };
  IndexJs.notAllowedToBid(prim);
}

var _map$13 = {"Web":"web","App":"app"};

var _revMap$13 = {"web":"Web","app":"App"};

function registrationSourceToJs(param) {
  return _map$13[param];
}

function registrationSourceFromJs(param) {
  return _revMap$13[param];
}

var _map$14 = {"AuctionDetails":"auction details","LotPage":"lot page","PlaceBidPage":"place bid page"};

var _revMap$14 = {"auction details":"AuctionDetails","lot page":"LotPage","place bid page":"PlaceBidPage"};

function auctionRegistrationOriginToJs(param) {
  return _map$14[param];
}

function auctionRegistrationOriginFromJs(param) {
  return _revMap$14[param];
}

function auctionRegistrationCompleted(saleId, registrationSource, bidMethod, customerId, auth0Id, preferredMemberFlag, productIdList, numProducts, restrictedSale, restrictedEnrollmentPeriod, enrollmentStatus, auctionRegistrationOrigin, userId, accountId, auctionId, auctionType, paddleId) {
  var segment = window.analytics;
  if (segment !== undefined) {
    Caml_option.valFromOption(segment).identify(undefined, {
          customer_id: customerId,
          auth0_id: auth0Id,
          preferred_member_flag: preferredMemberFlag
        }, undefined);
  }
  var prim_auction_registration_origin = auctionRegistrationOriginToJs(auctionRegistrationOrigin);
  var prim_auction_type = AuctionTypes$LiveRoom.auctionTypeToJs(auctionType);
  var prim_bid_method = bidMethodToJs(bidMethod);
  var prim_enrollment_status = Belt_Option.map(enrollmentStatus, enrollmentStatusToJs);
  var prim_in_app = sysInApp.contents;
  var prim_language = Belt_Option.map(sysLanguage.contents, languageToJs);
  var prim_registration_source = registrationSourceToJs(registrationSource);
  var prim = {
    account_id: accountId,
    auction_id: auctionId,
    auction_registration_origin: prim_auction_registration_origin,
    auction_type: prim_auction_type,
    auth0_id: auth0Id,
    bid_method: prim_bid_method,
    customer_id: customerId,
    enrollment_status: prim_enrollment_status,
    in_app: prim_in_app,
    language: prim_language,
    num_products: numProducts,
    paddle_id: paddleId,
    preferred_member_flag: preferredMemberFlag,
    product_id_list: productIdList,
    registration_source: prim_registration_source,
    restricted_enrollment_period: restrictedEnrollmentPeriod,
    restricted_sale: restrictedSale,
    sale_id: saleId,
    user_service_id: userId
  };
  IndexJs.auctionRegistrationCompleted(prim);
}

export {
  messageTypeToJs ,
  messageTypeFromJs ,
  bidResultToJs ,
  bidResultFromJs ,
  languageNewToJs ,
  languageNewFromJs ,
  currencySelectionOriginToJs ,
  currencySelectionOriginFromJs ,
  enrollmentStatusToJs ,
  enrollmentStatusFromJs ,
  languageToJs ,
  languageFromJs ,
  audioStreamToggleToJs ,
  audioStreamToggleFromJs ,
  participantTypeToJs ,
  participantTypeFromJs ,
  bidTypeToJs ,
  bidTypeFromJs ,
  contentTypeToJs ,
  contentTypeFromJs ,
  bidMethodToJs ,
  bidMethodFromJs ,
  audioStreamingToggleToToJs ,
  audioStreamingToggleToFromJs ,
  biddingInteractionTypeToJs ,
  biddingInteractionTypeFromJs ,
  sysInApp ,
  sysLanguage ,
  init ,
  logSegmentEvent ,
  bidPlaced ,
  authenticated ,
  navigated ,
  loginAttemptError ,
  auctionRoomEntered ,
  auctionRoomInteraction ,
  loginToBid ,
  audioStreamingToggle ,
  registrationPendingMessageViewed ,
  currencySelected ,
  notAllowedToBid ,
  registrationSourceToJs ,
  registrationSourceFromJs ,
  auctionRegistrationOriginToJs ,
  auctionRegistrationOriginFromJs ,
  auctionRegistrationCompleted ,
}
/* ./index.js Not a pure module */
